import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  smallSection: {
    marginBottom: theme.spacing() / 2,
    fontSize: "small",
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallSection}
      >
        Please note that any cards selected for a PSA submission are subject to
        a change in service level, due to eligibility based on the card's
        Declared Value. The Declared Value is your estimate of the value of the
        item <u>after it has been assigned a grade by PSA.</u> We ask that you
        form a realistic, educated estimate based on your own research. The
        Declared Value is also used for shipping insurance, in the event of a
        claim related to the item. For BGS, cards are eligible for any service
        level regardless of Declared Value.
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallSection}
      >
        If you desire a faster turnaround time on your order, you may select a
        service level above the Declared Value for your item. If we submit a
        card below its proper service level, it will get graded at that service
        level's turnaround time, but will be charged for the correct service
        level when complete. This sometimes happens with an incorrect submission
        or when a card's value increases while at PSA. GM Subs will assist you
        in making a decision on service levels based on your needs.
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallSection}
      >
        PSA service level maximum declared values allowed:
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallSection}
      >
        PSA Value / 100 Day - $500
        <br />
        PSA Regular / 40 Day - $1000
        <br />
        PSA Express - $2500
        <br />
      </Typography>
    </>
  );
};
